export { default } from './UserService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UserService/index.js